<template>
  <transition name="floating-button-fade">
    <div
      class="vue-floating-button"
      :style="`top:${this.top};right:${this.right};`"
      v-show="visible">
      <slot>
        <div class="default">
          <span>
            {{ text }}
          </span>
        </div>
      </slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'FloatingButton',
  data () {
    return {
      visible: false
    }
  },
  props: {
    text: {
      type: String,
      default: 'Click Me'
    },
    visibleoffset: {
      type: [String, Number],
      default: 600
    },
    visibleoffsetbottom: {
      type: [String, Number],
      default: 0
    },
    right: {
      type: String,
      default: '30px'
    },
    top: {
      type: String,
      default: '20px'
    }
  },
  mounted () {
    window.smoothscroll = () => {
      let currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll)
        window.scrollTo(0, Math.floor(currentScroll - (currentScroll / 5)))
      }
    }
    window.addEventListener('scroll', this.catchScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.catchScroll)
  },
  methods: {
    /**
     * Catch window scroll event
     * @return {void}
     */
    catchScroll () {
      const pastTopOffset = window.pageYOffset > parseInt(this.visibleoffset)
      const pastBottomOffset = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - parseInt(this.visibleoffsetbottom)
      this.visible = parseInt(this.visibleoffsetbottom) > 0 ? pastTopOffset && !pastBottomOffset : pastTopOffset
    }
  }
}
</script>

<style scoped>
  .floating-button-fade-enter-active,
  .floating-button-fade-leave-active {
    transition: opacity .7s;
  }
  .floating-button-fade-enter,
  .floating-button-fade-leave-to {
    opacity: 0;
  }

  .vue-floating-button {
    cursor:pointer;
    position: fixed;
    z-index: 1000;
  }

  .vue-floating-button .default {
    background-color: #f5c85c;
    border-radius: 3px;
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    text-align: center;
    width: 160px;
  }

  .vue-floating-button .default span{
    color:#ffffff;
  }

  .vue-floating-button--is-footer {
    bottom: 50% !important;
    position: absolute;
    transform: translateY(50%);
  }
</style>
